export default __webpack_public_path__ + "static/media/app-store-nov-2023-1000kbps.bb8f43a1.mov";